export const CURRENCY_SYMBOL = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  CAD: "CA$",
  AUD: "AU$",
  JPY: "¥",
  KRW: "₩",
  TWD: "NT$",
  BRL: "R$",
} as const;

export type CurrencyCode = keyof typeof CURRENCY_SYMBOL;

export const SUPPORTED_CURRENCIES = Object.fromEntries(
  (Object.keys(CURRENCY_SYMBOL) as CurrencyCode[]).map((code) => [code, code])
) as { [K in CurrencyCode]: K };
